import {Storage} from "@/Services/Storage";

export default {
    name : `Agent`,
    state: {
        agents: [],
    },
    getters: {
        getAgents: state => state.agents,
    },
    mutations: {
        setAgents: (state, agents) => {
            state.agents = agents;
        }
    },
    actions: {
        fetchAgents: async (context, payload) => {
            try {
                const response = await axios.get(window.bankApi + `kazangAgents/getAllAgent`);
                context.commit('setAgents', response.data.response)
                return response.data.response;
            } catch (error) {
                errorHandler.tomcatError(error)
            }
        },
        blockAgent: async (context, payload) => {
            try {
                const response = await axios.post(window.bankApi + `kazangAgents/blockKazangAgent`, {}, {
                    params: {
                        KazangRef: payload.KazangRef,
                        reason: payload.reason,
                        accountUser: payload.accountUser
                    }
                });
                return response.data.response;
            } catch (error) {
                errorHandler.tomcatError(error)
            }
        },
        unblockAgent: async (context, payload) => {
            try {
                const response = await axios.post(window.bankApi + `kazangAgents/unblockKazangAgent`, {}, {
                    params: {
                        KazangRef: payload.KazangRef,
                        reason: payload.reason,
                        accountUser: payload.accountUser
                    }
                });
                return response.data.response;
            } catch (error) {
                errorHandler.tomcatError(error)
            }
        },
        setAgentRate: async (context, payload) => {
            try {
                const response = await axios.post(window.bankApi + `stats/updateAgentRate`, {},{
                    params: {
                        AgentRate: payload.AgentRate,
                        bankid: payload.bankid
                    }
                })

                return response.data.response;
            } catch (e) {
                console.error('Error setting the agent rate', e)
                errorHandler.tomcatError(e);
                return false;
            }
        },
        setDelay: async (context, payload) => {
            const id = context.rootGetters.userCompany

            try {
                const response = await axios.post(window.bankApi + `stats/updatedelay`, {},{
                    params: {
                        delay: payload.delay,
                        bankid: payload.bankid ? payload.bankid : id,
                    }
                })

                return response.data.response;
            } catch (e) {
                console.error('Error setting the agent rate', e)
                errorHandler.tomcatError(e);
                return false;
            }
        },
        getAgentRate: async (context, bank) => {
            const id = context.rootGetters.userCompany
            try {
                const response = await axios.get(window.bankApi + `stats/getAgentRate`,{
                    params: {
                        bankid: id,
                    }
                })

                return response.data;
            } catch (e) {
                console.error('Error getting the agent rate', e)
                errorHandler.tomcatError(e);
                return false;
            }
        },
        getDelay: async (context, bank) => {
            const id = context.rootGetters.userCompany
            try {
                const response = await axios.get(window.bankApi + `stats/getDelay`,{
                    params: {
                        bankid: id,
                    }
                })

                return response.data;
            } catch (e) {
                console.error('Error getting the agent rate', e)
                errorHandler.tomcatError(e);
                return false;
            }
        },
        downloadAgentReport: async (context, payload) => {
            try {
                const queryParams = new URLSearchParams({
                    from: context.rootGetters.getGlobalDateRange.from,
                    to: context.rootGetters.getGlobalDateRange.to,
                });

                const url = `${bankApi}kazangAgents/getAllAgent/download-excel?${queryParams.toString()}`;

                const res = await axios.get(url, {
                    headers: {
                        "Api-Key": globalApiKey,
                    },
                    responseType: 'blob',
                });

                const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
                const downloadUrl = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = downloadUrl;
                const today = new Date();
                const formattedDate = today.toISOString().slice(0, 10);
                link.setAttribute('download', `Agents-report-${formattedDate}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();

                return true;
            } catch (error) {
                console.error("Error exporting statement:", error);
                errorHandler.tomcatError(error);
                return false;
            }
        },
    },
}
